import Resource from '@/api/resources/Resource'

class RegistrySubrequestPrintService extends Resource {
    async generateLabelsWithCopiesNumber(labId, requestId, subrequests) {
        return this.axios.put(`/registry/laboratories/${labId}/requests/${requestId}/generateLabelsWithCopies`,
            subrequests,
            {
                headers: {
                    type: 'application/pdf'
                },
                responseType: 'arraybuffer'
            }
        ).then(response => response.data)
    }
}

export default new RegistrySubrequestPrintService()
